import ApiRequest from '../util/ApiRequest'
export default class Tsn {
    static getAll = async (datasourceOptions) => {
        const params = new URLSearchParams(datasourceOptions).toString()
        return await ApiRequest.set(`v1/tsns?${params}`, 'GET')
    }
    static getSelf = async (datasourceOptions) => {
        const params = new URLSearchParams(datasourceOptions).toString()
        return await ApiRequest.set(`v1/member-tsn/self?${params}`, 'GET')
    }
    static getById = async (id, datasourceOptions) => {
        const params = new URLSearchParams(datasourceOptions).toString()
        return await ApiRequest.set(`v1/tsn/${id}?${params}`, 'GET')
    }

    static register = async (tsn_id, payload) => {
        return await ApiRequest.set(`v1/tsn-register/${tsn_id}`, 'POST', payload)
    }
}
